const model = {
  template_name: {
    name: "название",
    sex: 0,
    required: true,
    checkLength: false
  }
};

module.exports = model;
